
<div class="overlay">
  <div class="message-box">
    <img src="maintenance.svg">
    <div class="paragraph-combination">
      <div class="title">{{('maintenance:maintenance' | translate)()}}</div>
      <div class="message">{{('maintenance:maintenanceDescription' | translate)()}}</div>
    </div>
    @if (begin() && duration()) {
      <div class="paragraph-combination">
        <div class="message">{{('maintenance:begin' | translate)()}}{{i18n.dateTime(begin()!)()}}</div>
        <div class="message">{{('maintenance:duration' | translate)()}}{{duration()!}}</div>
      </div>
    }
    <div class="button-bar">
      <ngt-button (ngtClick)="serverStatusService.serverStatus.set('unknown')">{{('maintenance:tryAgain' | translate)()}}</ngt-button>
    </div>
  </div>
</div>
